import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Reaction } from "./Reaction.jsx";
import { makeMyWorkReactionsByObjectSelector } from "../../store/selectors/selector.reactions.jsx";

export const MyWorkReactions = ({ onClick, objectId, objectType, className }) => {
  const getMyWorkReactionsByObject = useMemo(makeMyWorkReactionsByObjectSelector, []);
  const reactions = useSelector((state) => getMyWorkReactionsByObject(state, objectId, objectType));

  return reactions && reactions.length > 0 ? (
    <span className={classNames("my_work_reactions", className)}>
      <span className="current_reactions tw-flex">
        {reactions.map((reaction, index) => (
          <Reaction
            type={reaction.type}
            key={index}
            onClick={onClick}
            shortName={reaction.shortName}
            count={reaction.count}
          />
        ))}
      </span>
    </span>
  ) : null;
};

MyWorkReactions.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  objectId: PropTypes.number,
  objectType: PropTypes.string,
};
